import {GETSUBSCRIPTION, GETPACKAGES, GETCOUPON, GETPACKAGEONE, GETCOUPONONE, GETCOUPONFILTER, EDITPACKAGE, ADDPACKAGE} from '../actions/constant';

const INITIAL_STATE = {
    stats: {},
    packages: {},
    coupon: {},
    coupon_one: {},
    package_one: {},
    error: ''
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type){
        case GETSUBSCRIPTION:
            return {...state, stats:action.payload.data};
        case GETPACKAGES:
            return {...state, packages:action.payload.data};
        case EDITPACKAGE:
            return {...state, error:action.payload.error};
        case ADDPACKAGE:
            return {...state, error:action.payload.error};
        case GETPACKAGEONE:
            return {...state, package_one:action.payload.data};
        case GETCOUPON:
            return {...state, coupon:action.payload.data};
        case GETCOUPONFILTER:
            return {...state, coupon:action.payload.data};
        case GETCOUPONONE:
            return {...state, coupon_one:action.payload.data};

    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_subscription.js